export var SessionStorageKey;
(function (SessionStorageKey) {
    SessionStorageKey["CURRENT_REVIEWER_ID"] = "currentReviewerId";
    SessionStorageKey["CURRENT_CARRIER_CODE"] = "currentCarrierCode";
    SessionStorageKey["CURRENT_REVIEWER_ORG_CODE"] = "currentReviewerOrgCode";
    SessionStorageKey["CURRENT_RETURN_URL"] = "returnUrl";
    SessionStorageKey["ONLOAD_ESTIMATE_DOCUMENT_REVISION_NUMBER"] = "onLoadEstimateDocumentRevisionNumber";
    SessionStorageKey["CURRENT_SHOP_KEY"] = "currentShopKey";
})(SessionStorageKey || (SessionStorageKey = {}));
//# sourceMappingURL=SessionStorageKey.js.map